import { render, staticRenderFns } from "./tarife-table.vue?vue&type=template&id=722140a2&"
import script from "./tarife-table.vue?vue&type=script&lang=js&"
export * from "./tarife-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports